import { createContext } from "react";
import type { ReleaseSectionKey } from "./sections.js";

// The action-rail column's DOM host: provided by ReleaseDetailScreen, consumed by <SectionRail> (sectionRail.tsx)
// to portal a section's buttons into the shell's sticky rail. Its own module so the .tsx exports only a
// component (react-refresh / fast-refresh).
export const SectionRailContext = createContext<HTMLElement | null>(null);

// Lets a section send the reader to ANOTHER section (e.g. Smart Link → "Go to Assets", ART-219). Provided by
// ReleaseDetailScreen with its own `onSection`, which the route supplies — so the same call lands on the right
// URL under the artist shell and under the roster. Null when a section is mounted in isolation (a unit test),
// where a caller simply offers no button.
export const ReleaseSectionNavContext = createContext<((key: ReleaseSectionKey) => void) | null>(null);
